export const KEY_DEFAULT_ERROR = 'ERROR_OCCURRED';
